import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BackButtonComponent } from '../back-button/back-button.component';
import { Location } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { PasswordModule } from 'primeng/password';
import { LambdaService } from 'src/app/services/lambda.service';
import { MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { Ripple } from 'primeng/ripple';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-subscription-details',
  imports: [BackButtonComponent, ButtonModule, InputTextModule, DropdownModule, FormsModule, CommonModule, PasswordModule, ToggleSwitch, CheckboxModule, ToastModule],
  templateUrl: './subscription-details.component.html',
  styleUrl: './subscription-details.component.scss',
  providers: [MessageService]
})
export class SubscriptionDetailsComponent {
  subscription: any = {};
  subscriptionEdited: any = {}
	loading = false;
  selectedProductTypes: string[] = [];
  id: any;

  isEditing: boolean = false;
	shopProductTypesAllow: string[] = [];
  selectedImportExports: string[] = [];
  selectedLogs: string[] = [];
  selectedPlan: string[] = [];
	productTypeOptions = [
    { label: 'Convencional', value: '1' },
    { label: 'Sesion', value: '2' },
    { label: 'Seguro', value: '3' },
    { label: 'Paquete', value: '4' }
  ];
  
  logOptions = [
    { label: 'Ordenes', name: 'sales', value: 0, checked: false},
    { label: 'Beneficiarios', name: 'beneficiaries', value: 0, checked: false},
    { label: 'Clientes', name: 'clients', value: 0, checked: false}
  ];

  importExportOptions = [
    { label: 'Importar Clientes', name: 'importClients', value: 0, checked: false},
    { label: 'Importar Productos', name: 'importProducts', value: 0, checked: false},
    { label: 'Exportar Clientes', name: 'exportClients', value: 0, checked: false},
    { label: 'Exportar Proveedores', name: 'exportProviders', value: 0, checked: false}
  ];

  planOptions = [
    { label: 'Beneficiarios BO', name: 'beneficiariesBO', value: 0, checked: false},
    { label: 'Planes por cliente BO', name: 'plansByClientBO', value: 0, checked: false},
    { label: 'Beneficiarios CC', name: 'beneficiariesCC', value: 0, checked: false},
    { label: 'Grafico Planes', name: 'plansChart', value: 0, checked: false}
  ];

  get shopProductTypesAllowString(): string {
    return this.shopProductTypesAllow.join(',');
  }

  constructor(
    private route: ActivatedRoute,
    private location: Location,
		private lambdaService: LambdaService,
		private messageService: MessageService
  ) {}

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
		this.getSubscriptionData(this.id);
    console.log("subscription id ", this.id);
  }

	getSubscriptionData(subscriptionId: any){
		this.loading = true;
    this.lambdaService
    .getSubscriptionData(subscriptionId)
    .then((data: any) => {
      console.log(data,"subscription data");
      this.subscription = data.data;
      this.selectedProductTypes = this.subscription.shopProductTypesAllow
        ? this.subscription.shopProductTypesAllow.split(',')
        : [];
      const importExportData = this.subscription.shopImportExportAllow;
      this.importExportOptions.forEach(option => {
        const value = importExportData[option.name] || 0;
        option.value = value;
        option.checked = value === 1;
      });
      const logOptions = this.subscription.shopLogsAllow;
      this.logOptions.forEach(option => {
        const value = logOptions[option.name] || 0;
        option.value = value;
        option.checked = value === 1;
      });
      const planData = this.subscription.shopPlanAllow;
      this.planOptions.forEach(option => {
        const value = planData[option.name] || 0;
        option.value = value;
        option.checked = value === 1;
      });
      console.log("importExportOptions", this.importExportOptions);
      console.log("logOptions", this.logOptions);
      console.log("planOptions", this.planOptions);
      this.subscription.shopPosAccess = this.subscription.shopPosAccess == 1 ? true : false;
      this.subscription.shopAnaliticsAccess = this.subscription.shopAnaliticsAccess == 1;
      this.subscription.shopInfobipIntegrationAllow = this.subscription.shopInfobipIntegrationAllow == 1;
      this.subscription.shopValidateClientAccess = this.subscription.shopValidateClientAccess == 1;
      this.subscription.shopCalendarAccess = this.subscription.shopCalendarAccess == 1;
      this.subscription.shopCashRegisterAccess = this.subscription.shopCashRegisterAccess == 1;
      this.subscriptionEdited = this.subscription;
			console.log(this.subscription," subscription")
		})
    .catch((error: Error) => {
      console.error(error);
    })
    .finally(() => {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    });
  }

	saveSubscription() {
		this.loading = true;
    console.log("shopImportExportAllowJson",this.shopImportExportAllowJson)
    console.log("shopLogsAllowJson",this.shopLogsAllowJson)
    console.log("shopPlanAllowJson",this.shopPlanAllowJson)
		this.lambdaService.updateShopSubscriptionData(
			this.subscription.shopSubscriptionId,
			this.subscription.shopSubscriptionName,
      this.subscription.shopPosAccess = this.subscription.shopPosAccess ? 1 : 0,
      this.subscription.shopAnaliticsAccess = this.subscription.shopAnaliticsAccess ? 1 : 0,
			this.subscription.shopMaxUsers,
			this.subscription.shopMaxProducts,
			this.subscription.shopProductTypesAllow,
      this.subscription.shopInfobipIntegrationAllow = this.subscription.shopInfobipIntegrationAllow ? 1 : 0,
      this.subscription.shopValidateClientAccess = this.subscription.shopValidateClientAccess ? 1 : 0,
      this.subscription.shopCalendarAccess = this.subscription.shopCalendarAccess ? 1 : 0,
      this.subscription.shopCashRegisterAccess = this.subscription.shopCashRegisterAccess ? 1 : 0,
      this.shopImportExportAllowJson,
      this.shopLogsAllowJson,
      this.shopPlanAllowJson 
		)
		.then((data: any) => {
			console.log(data,"store update");
      this.getSubscriptionData(this.id);
			this.showSuccess();
		})
    .catch((error: Error) => {
			console.error(error);
			this.showSuccess();
    })
    .finally(() => {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    });
	}

  onProductTypesChange() {
    console.log(this.selectedProductTypes)
    this.subscription.shopProductTypesAllow = this.selectedProductTypes.join(',');
    console.log(this.subscription.shopProductTypesAllow)
  }

  onIECheckboxChange(event: any, option: any) {
    option.value = event.checked ? 1 : 0;
    console.log("importExportOptions", this.importExportOptions);
  }

  get shopImportExportAllowJson(): string {
    const importExportJson: { [key: string]: number } = {};
    for (const opt of this.importExportOptions) {
      importExportJson[opt.name] = opt.value;
    }
    return JSON.stringify(importExportJson);
  }

  onLogsChange(event: any, option: any) {
    option.value = event.checked ? 1 : 0;
    console.log("logOptions", this.logOptions);
  }

  get shopLogsAllowJson(): string {
    const logJson: { [key: string]: number } = {};
    for (const opt of this.logOptions) {
      logJson[opt.name] = opt.value;
    }
    return JSON.stringify(logJson);
  }

  onPlanChange(event: any, option: any) {
    option.value = event.checked ? 1 : 0;
    console.log("planOptions", this.planOptions);
  }

  get shopPlanAllowJson(): string {
    const planJson: { [key: string]: number } = {};
    for (const opt of this.planOptions) {
      planJson[opt.name] = opt.value;
    }
    return JSON.stringify(planJson);
  }

	showSuccess() {
		this.messageService.add({ severity: 'success', summary: 'Éxito', detail: 'Cambios guardados con éxito' });
	}

	showError() {
		this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error al guardar' });
	}

  toggleEdit() {
    if(this.isEditing == true){
      this.subscriptionEdited = this.subscription;
    }
    this.isEditing = !this.isEditing;
  }

}
